{
  "longPressMessage": "长按或按 Alt + 向下方向键以打开菜单"
}
